import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Section = styled.section`
  background-color: ${themeGet('colors.white')};
  position: relative;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const HeadingWrapper = styled.div`
  margin-bottom: 40px;
  h2 {
    color: ${themeGet('colors.black')};
    font-size: 36px;
    font-weight: 700;
  }
  p {
    color: ${themeGet('colors.black')};
    font-size: 18px;
    margin-top: 10px;
    }
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 1100px;
  gap: 40px;
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 20px;
     align-items:center;
  }
`;

export const Illustration = styled.figure`
  background-color: ${themeGet('colors.primary')};
  border-radius: 15px;
  flex: 1;
  display: flex;
  justify-content: center;
  img {
     max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  @media only screen and (max-width: 1200px) {
    order: -1; /* Moves the image above the form */
    width: 80%;
  }
`;

export const FormContainer = styled.div`
background: ${themeGet('colors.white')};
flex: 1;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  text-align: left;
  width: 100%;
  
  @media (max-width:1200px) {
    width: 80%;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
`;

export const Button = styled.button`
  background: ${themeGet('colors.primary')};
  color: white;
  padding: 12px;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: ${themeGet('colors.secondary')};
  }
`;
